var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuperapp = function SvgSuperapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.08 20.35a2.425 2.425 0 1 0-3.43-3.428l-2.576 2.575a2.425 2.425 0 1 0 3.43 3.429zm.964.965a3.788 3.788 0 1 0-5.359-5.358L4.11 18.532a3.788 3.788 0 1 0 5.358 5.358zM8.504 5.074a2.425 2.425 0 0 0-3.43 3.43l2.576 2.575a2.425 2.425 0 0 0 3.43-3.43zm.964-.964A3.79 3.79 0 0 0 4.11 9.468l2.575 2.575a3.79 3.79 0 0 0 5.359-5.358zM20.35 16.922a2.425 2.425 0 0 0-3.43 3.429l2.576 2.575a2.425 2.425 0 0 0 3.43-3.43zm.965-.965a3.79 3.79 0 0 0-5.359 5.358l2.576 2.575a3.79 3.79 0 0 0 5.358-5.358zM23.89 4.11a3.79 3.79 0 0 1 0 5.358l-2.575 2.575a3.79 3.79 0 0 1-5.359-5.358l2.576-2.575a3.79 3.79 0 0 1 5.358 0",
    clipRule: "evenodd"
  })));
};
export default SvgSuperapp;